import { apiService } from './api'
import { QuestionInput, QuestionWithAnswer } from '../types/question'

export class QuestionService {
  /**
   * 設問作成
   */
  static async createQuestion(
    testId: string,
    data: QuestionInput
  ): Promise<{ message: string; question: QuestionWithAnswer }> {
    return await apiService.post<{ message: string; question: QuestionWithAnswer }>(
      `/questions/test/${testId}`,
      data
    )
  }

  /**
   * 設問更新
   */
  static async updateQuestion(
    id: string,
    data: Partial<QuestionInput>
  ): Promise<{ message: string; question: QuestionWithAnswer; warning?: string }> {
    return await apiService.put<{
      message: string
      question: QuestionWithAnswer
      warning?: string
    }>(`/questions/${id}`, data)
  }

  /**
   * 設問削除
   */
  static async deleteQuestion(id: string): Promise<{ message: string }> {
    return await apiService.delete<{ message: string }>(`/questions/${id}`)
  }

  /**
   * 設問並び替え
   */
  static async reorderQuestions(
    testId: string,
    questionIds: string[]
  ): Promise<{ message: string }> {
    return await apiService.put<{ message: string }>(`/questions/test/${testId}/reorder`, {
      questionIds,
    })
  }
}
